/**
 * The web app's Firebase config, inlined at build time.
 *
 * Every value here is public by design: Firebase web config is an address, not a
 * credential, and the security rules are what actually protect the data. Absent
 * config is not an error - it is a deployment that has not turned voting on.
 *
 * This sits apart from `firestore.ts` so that asking *whether voting is on* costs
 * nothing. `firestore.ts` pulls in the Firebase SDK, about a third of the bundle,
 * and the panel has to answer that question on its first render - before it knows
 * whether it may offer the buttons at all.
 */
export interface FirebaseWebConfig {
  readonly apiKey: string
  readonly authDomain: string
  readonly projectId: string
  readonly appId: string
}

export const readFirebaseConfig = (
  env: Record<string, string | undefined>,
): FirebaseWebConfig | undefined => {
  const apiKey = env.VITE_FIREBASE_API_KEY
  const authDomain = env.VITE_FIREBASE_AUTH_DOMAIN
  const projectId = env.VITE_FIREBASE_PROJECT_ID
  const appId = env.VITE_FIREBASE_APP_ID

  if (!apiKey || !authDomain || !projectId || !appId) return undefined
  return { apiKey, authDomain, projectId, appId }
}
